import { createSelector } from "reselect";

const personalDetailSelector = state => state.personalDetail;
const configSelector = state => state.config;
const waitingListSelector = state => state.waitingList;

const getState = (personalDetail, config, waitingList) => {
  return {
    verifyCode: personalDetail.verifyCode,
    isOpen: personalDetail.isVerifyDrawerOpen,
    requireWaitingList: waitingList.required,
    useRecaptcha: config.reCaptchaEnabled
  };
};

const verificationSelector = createSelector(
  personalDetailSelector,
  configSelector,
  waitingListSelector,
  getState
);

export { verificationSelector };



// WEBPACK FOOTER //
// ./src/modules/ContactForm/selectors/verificationSelector.js